import React, { useState } from "react";
import ManageUser from "../ManageUser";
import Drawer from "../../../../drawer/Drawer";
import DrawerHeader from "./DrawerHeader";

const ManageUserDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [previousSize, setPreviousSize] = useState(() => {
    return localStorage.getItem("drawer-previous-size") || "";
  });

  return (
    <Drawer
      open={open}
      onClose={(val) => {
        setSelectedTab(0);
        close(val);
      }}
      actualSize={[0, 1].includes(selectedTab) ? "xl" : "xl6"}
      size={
        previousSize
          ? previousSize
          : [0, 1].includes(selectedTab)
          ? "xl"
          : "xl6"
      }
      title={
        data?._id ? (
          <div className="uppercase tracking-tighter font-bold">
            Update User /{" "}
            <span className="text-gray-400">
              {data?.firstName} {data?.lastName}
            </span>
          </div>
        ) : (
          <span className="tracking-tighter font-bold uppercase">Add User</span>
        )
      }
      subtitle="View, update and modify user details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-42px)]"
      closeBtn={false}
      header={<DrawerHeader />}
    >
      <div className="h-full overflow-y-auto">
        <ManageUser
          getResponse={getResponse}
          close={(val) => {
            setSelectedTab(0);
            close(val);
          }}
          data={data}
          selectedTab={selectedTab}
          setSelectedTab={(val) => {
            setPreviousSize(localStorage.getItem("drawer-previous-size") || "");
            setSelectedTab(val);
          }}
        />
      </div>
    </Drawer>
  );
};

export default ManageUserDrawer;
